<table class="color-palette">
  @for (row of rows; track row) {
    <tr>
      @for (color of row; track color) {
        <td class="color-option" [style.backgroundColor]="color" (click)="selectColor(color, true)">
          @if (color === this.selectedColor) {
            <span [style.color]="getCheckColor(color)">&#10004;</span>
          }
        </td>
      }
    </tr>
  }
</table>
